<div class="common-wrapper">
    <div class="main-hd-txt">
        <span>
            <h4>ACT<span class="head-btn-style">
                <button *ngIf="!listView" (click)="goToBackTab()" class="go-back-btn-head" title="Back Tab">
                    <i class="bi bi-arrow-left-circle"></i> Back</button></span><span class="head-btn-style">
                    <button *ngIf="!listView" (click)="save($event)" class="save-btn-head" [disabled]="saveDisabled" title="Save">
                    <i class="bi bi-file-earmark-plus"></i> Save</button></span></h4>
        </span>
    </div>
    <div *ngIf="listView" class="top-btns">
        <grid [entities]="acts" [actionExclude]="['feedback','column']" [checkboxCol]="true"
            [entityColumns]="actColumns" [selectionField]="'Act_Id'" [addEntityIcon]="'bi bi-plus-square'"
            [addEntityCaption]="'Add'" [downloadEntityCaption]="'Download'" (downloadEntities)="onExcelExport()"
            (addEntity)="addAct($event)" (editEntity)="editAct($event)"
            (refreshEntities)="refreshAct($event)" (deleteEntity)="deleteAct($event)"
            (onPaginationChange)="onPaginationChange($event)" [serverPagination]="true" [pageSizes]="pageSizes"
            [pageSize]="defaultPageSize" [skip]="pageSkip" (onFilterChange)="onFilterChange($event)"></grid>

    </div>

    <div *ngIf="!listView">  
        <div class="row sub-head"> 
            <div class="col-md-7 text-bold">
                {{ formCaption }}
            </div>
            <div class="col-md-5 text-end">
                <button (click)="clearAct()" class="btn-3 bt-3-ic"><span>Clear</span></button>
                <button (click)="revertChanges()" class="btn-3 bt-4-ic"><span>Revert Changes</span></button>
                <button (click)="gotoBack()" class="btn-3 bt-4-ic"><span>Go Back</span></button>
            </div> 
        </div>
        <div class="col-md-12 content-area">
            <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Act Name'" [mandatory]="true" [maxlength]="100" [formData]="entity"
                [fieldName]="'ActName'" [(ngModel)]="entity.ActName" ngDefaultControl></textbox>
         </div>
            </div>
            <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Description'" [mandatory]="false" [multiline]="true" [formData]="entity"
                            [maxlength]="500" [fieldName]="'Description'" [(ngModel)]="entity.Description"
                            ngDefaultControl>
                        </textbox>
                </div>
            </div>
            <div class="row"> 
                <div class="col-md-8 mb-2"> 
                    <input id="file-input" type="file" (change)="fileChanged($event);" accept=".pdf,.doc" /> 
                    <!-- accept=".pdf,.doc,.docx" />  -->
                    <a id="link" download>{{documentdownload}}</a>
                    <input type="button" id="downloadbutton"  *ngIf="this.isDownloadButtonVisible"
                            (click)="downloadFunction(entity)" value="Download" downloadLink/>
                    <span>
                        <!-- <img [src]="url" height="70" class="imgClass"> -->
                        <input type="button" id="removeImage1" class="close" *ngIf="this.isButtonVisible"
                            (click)="removeImage($event);" value="x" />
                    </span>
                </div> 
            </div> 
            <div class="row">
                <div class="col-md-4 mb-2">
                    <checkbox [caption]="'Active'" [(ngModel)]="entity.IsActive"></checkbox>
                </div>
            </div>
            <!-- <div class="row">
                <div class="col-md-1">
                    <btn [label]="'Back'" (click)="goToBackTab()" [class]="'btn-next btn-11'"
                        [type]="'button'" title="Back Tab"></btn>
                </div>
                <div class="col-md-4 mb-2">
                    <btn [label]="'Save'" (click)="save($event)" [class]="'btn-1 btn-11'" [disabled]="saveDisabled"
                        [type]="'button'"></btn>
                </div>
            </div> -->
        </div>

    </div>
</div>
<ng-template #view let-dataItem let-rowIndex="rowIndex">
    <i class="bi bi-eye-fill" (click)="open(dataItem)"></i>
  </ng-template>
  <kendo-dialog title="Act Details" *ngIf="opened" (close)="close()" [height]="500" [width]="1000">
    <div class="col-md-12 content-area">
        <div class="row">
        <div class="col-md-4 br-table-data">
            <label for="ActName" class="label label-1">Act Name : </label> {{details.ActName }}
          </div>
          <div class="col-md-4 br-table-data">
            <label for="Description" class="label label-1">Description : </label> {{details.Description }}
          </div>
        </div>
        </div>
    </kendo-dialog>
<kendo-excelexport [data]="acts.data" [collapsible]="true" fileName="Act.xlsx" #excelexport>
    <kendo-excelexport-column field="SlNo" title="Sl.No." [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="ActName" title="Act" [width]="200">
    </kendo-excelexport-column> 
    <kendo-excelexport-column field="Description" title="Description" [width]="200">
    </kendo-excelexport-column>  
    <kendo-excelexport-column field="Active" title="Active" [width]="200">
    </kendo-excelexport-column> 
</kendo-excelexport>